import { useState, useRef } from 'react'
import classNames from 'classnames'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import { languageObjectSelector } from 'i18n/selectors'
import { languagesSelector } from 'wordpress/selectors'
import featureToggles from 'shared/featureToggles'
import useClickOutside from 'shared/hooks/useClickOutside'

import { headerStateSelector } from '../selectors'

import GetAppContainer from './GetAppContainer'
import DropdownLink from './DropdownLink'
import BasketContainer from './BasketContainer'
import UserContainer from './UserContainer'
import Flag from './Flag'

import '../styles/animations.scss'

const Language = ({ slug, flag, name, current }) => (
    <li className="d-flex m-0">
        <DropdownLink
            className={classNames('px-3', 'py-2', 'w-100', {
                active: current,
            })}
            language={slug}
            replace>
            <Flag flag={flag} name={name} />
            <span className="label">{slug}</span>
        </DropdownLink>
    </li>
)

const $LanguageDropdown = ({ languages }) => (
    <div className="arrow-box p-0">
        <ul>
            {Object.values(languages).map(language => (
                <Language {...language} key={language.slug} />
            ))}
        </ul>
    </div>
)

export const LanguageDropdown = compose(
    connect(
        createStructuredSelector({
            languages: languagesSelector,
        })
    )
)($LanguageDropdown)

const $NavLanguageButton = ({ language, moreThanOneLanguage }) => {
    const [isDropdownVisible, setIsDropdownVisible] = useState(false)
    const ref = useRef()
    const transitionComponentRef = useRef()

    const toggleDropdown = () => setIsDropdownVisible(prev => !prev)

    useClickOutside(ref, () => setIsDropdownVisible(false))

    return (
        <div
            className="indigo-text-btn nav-language-btn"
            onMouseEnter={toggleDropdown}
            onMouseLeave={toggleDropdown}
            ref={ref}>
            <Flag flag={language.flag} name={language.name} />
            <span className="label">{language.slug}</span>
            {moreThanOneLanguage && <span className="nav-ic-down-arrow" />}
            {isDropdownVisible && (
                <TransitionGroup className="nav-dropdown-transition">
                    <CSSTransition
                        nodeRef={transitionComponentRef}
                        key="language-dropdown"
                        timeout={{ enter: 100, exit: 100 }}
                        classNames="nav-dropdown-transition">
                        <div ref={transitionComponentRef}>
                            <LanguageDropdown />
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            )}
        </div>
    )
}

const moreThanOneLanguageSelector = createSelector(languagesSelector, languages => Object.keys(languages).length > 1)
const NavLanguageButton = connect(
    createStructuredSelector({
        header: headerStateSelector,
        language: languageObjectSelector,
        moreThanOneLanguage: moreThanOneLanguageSelector,
    })
)($NavLanguageButton)

const NavRight = () => (
    <div className="nav-right">
        <ul className="horizontal-list">
            {featureToggles.showDownloadApp && (
                <li>
                    <GetAppContainer />
                </li>
            )}
            <li>
                <UserContainer isResponsive={false} />
            </li>
            {featureToggles.hasBasket && (
                <li>
                    <BasketContainer />
                </li>
            )}
            <li>
                <NavLanguageButton />
            </li>
        </ul>
    </div>
)

export default NavRight
